import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { IHistoriaWHR, WharehouseModel } from "../../../models/whr/warehouse.model";
import { HttpClient } from "@angular/common/http";
import { CONTROL_APP_CONST } from "../../../config/control-app.constant";
import { tap } from "rxjs/operators";
import { NGXLogger } from "ngx-logger";
import { WhrCotizarDataModel, WhrProductoCotizacionModel } from "../../../shared/whr-cotizar/whr-cotizar.model";
import { initWaitMe, stopWaitMe, WaitMeOptionModel } from "../../../../control-core/util/waitme.util";
import { ErrorService } from "../../../../control-core/services/error.service";
import { TranslateService } from "@ngx-translate/core";
import { notify, SUCCESS_NOTIFY } from "../../../../control-core/util/notify.util";
import {
  ISimpleTableConfig, SimpleTableConfig
} from "../../../../control-core/shared/simple-table/simple-table.component";

import Swal from 'sweetalert2'

import * as cloneDeep from 'lodash/cloneDeep';
import { GeparametersService } from '../../../../control-core/services/geparameters.service';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../../../control-core/services/auth.service';
import { UserCModel } from '../../../models/user.model';
import { extraerNumeros } from "../../../../control-core/util/util";
import { DestinatarioModel } from "../../../models/general/cliente.model";
import { ValidatorService } from "../../../../control-core/services/validator-service";

declare let jquery: any;
declare let $: any;

@Component({
  selector: 'app-whr-detalle',
  templateUrl: './whr-detalle.component.html'
})
export class WhrDetalleComponent implements OnInit {

  nrowhr = '';
  warehouse: WharehouseModel = new WharehouseModel();
  warehouseEdit: WharehouseModel = new WharehouseModel();
  cotizarData: WhrCotizarDataModel;
  stblHistoria: ISimpleTableConfig;

  detalleNewComentario = {hasError: false, errorText: "", comentario: ''};
  enviandomensaje: boolean = false;

  ordenPagoRef: string;
  peso_label: string = '';
  rem_direccion: string = '';
  des_direccion: string = '';

  public confirmaActu = this._translate.instant('CONFIR_UPDATE_DATA_LABEL');
  public _YES_LABEL = this._translate.instant('YES_LABEL');
  public _NO_LABEL = this._translate.instant('NO_LABEL');
  public _VALOR_DECLARADO_LABEL = this._translate.instant('VALOR_DECLARADO_LABEL') + ' (USD)';
  public _CODIGO_POSTAL_LABEL = this._translate.instant('CODIGO_POSTAL_LABEL');

  readonly OBSERVACION_MAX_LENGTH = 160;

  checkFormEdit = {
    errorText: 'CAMPO_REQUIRED_LABEL',
    errorTextVlrDeclarado: '',
    hasErrorVlrDeclarado: false,
    hasErrorZip: false,
    hasErrorDireccion: false,
    hasErrorPaqdesc: false,
    errorTextPaqdesc: 'CAMPO_REQUIRED_LABEL'
  };

  private _destinatario: DestinatarioModel = new DestinatarioModel();
  private _idRootPanel = '#detalleWHR';
  private _idCotizaWHRModal = '#cotizarWHRModal';
  private _idAddComentWHRModal = '#addComentWHRModal';
  private _ordenPagoModal = '#ordenPagoModal';
  private _editarWarehouseModal = '#editarWarehouseModal';
  private _WAREHOSE_INCOMPLETE = this._translate.instant('WAREHOSE_INCOMPLETE');
  private _EDITA_WHR_ADD_VALDEC = this._translate.instant('EDITA_WHR_ADD_VALDEC');
  private _showCotizarAfterUpdate = false;
  private _limitVlrDeclarado = 0;
  private _limitVlrAsegurado = 0;
  private _minVlrAsegurado = 0;
  private _minVlrDeclarado = 0;
  private _userInfoSubscription: Subscription = null;
  private _geparametersSubcription: Subscription = null;

  public userInfo: UserCModel = new UserCModel();

  constructor(private _state: StateService,
              private _logger: NGXLogger,
              private _parameters: GeparametersService,
              private _errorService: ErrorService,
              private _translate: TranslateService,
              private _authService: AuthService,
              private _validatorService: ValidatorService,
              private _http: HttpClient) {
    this.cotizarData = new WhrCotizarDataModel();
    this.warehouse = new WharehouseModel()
  }

  ngOnInit() {

    this._geparametersSubcription = this._parameters.state$.subscribe((estado) => {
      if (estado == 'ready') {
        this._limitVlrDeclarado = this._parameters.getNumval('CTRLBX_LIMIT_VLR_DECLARADO');
        this._limitVlrAsegurado = this._parameters.getNumval('CTRLBX_LIMIT_VLR_ASEGURADO');
        this._minVlrAsegurado = this._parameters.getNumval('CTRLBX_MIN_VLR_ASEGURADO');
        this._minVlrDeclarado = this._parameters.getNumval('CTRLBX_MIN_VLR_DECLARADO');
      }
    });

    this._userInfoSubscription = this._authService.userInfo$
        .subscribe((iUserInfo: UserCModel) => {
          this.userInfo = iUserInfo;
        });

    this.stblHistoria = new SimpleTableConfig<IHistoriaWHR>([
      {
        name: 'fecha',
        label: 'DATE_LABEL'
      },
      {
        name: 'statu',
        label: 'NAME_LABEL'
      },
      {
        name: 'observacion',
        label: 'OBSERVACION_LABEL'
      }]);
    this.consultaWarehouse();
  }

  showEditarWHRModal() {
    this.warehouseEdit = cloneDeep(this.warehouse);
    $(this._editarWarehouseModal).modal('show');
  }

  consultaWarehouse() {
    initWaitMe(this._idRootPanel);
    this.nrowhr = this._state.params.nro_whr;
    this._http.get<WharehouseModel>(`${CONTROL_APP_CONST.API_URL}detalleWarehouse/${this.nrowhr}`)
        .pipe(tap(warehouse => {
          this.nrowhr += (warehouse.tracking != null ? (" - " + warehouse.tracking) : '');
          this.peso_label = warehouse.peso + ' lb ('
              + warehouse.alto + ' X ' + warehouse.largo + ' X ' + warehouse.ancho + ') in';
          if (!this._validatorService.isEmpty(warehouse.ciudadrem)) {
            this.rem_direccion = this._getTextoDireccion(warehouse.ciudadrem.departamento.pais.nombre,
                warehouse.ciudadrem.departamento.nombre, warehouse.ciudadrem.nombre, warehouse.remdireccion,
                warehouse.remzip
            );
          }
          warehouse.destelefono = extraerNumeros(warehouse.destelefono);
          warehouse.deszip = this._validatorService.isEmpty(warehouse.deszip) ? '' : extraerNumeros(warehouse.deszip);
        }))
        .map(warehouse => {
          if (this._validatorService.isEmpty(warehouse.tienda))
            warehouse.tienda = {nombre: "", id: ""};

          if (this._validatorService.isEmpty(warehouse.transportadora))
            warehouse.transportadora = {nombre: "", id: ""};

          warehouse.rememail = this._validatorService.isEmpty(warehouse.rememail) ? '' : warehouse.rememail;
          warehouse.desemail = this._validatorService.isEmpty(warehouse.desemail) ? '' : warehouse.desemail;
          warehouse.remtelefono = this._validatorService.isEmpty(warehouse.remtelefono) ? '' : warehouse.remtelefono;
          warehouse.remapellidos = this._validatorService.isEmpty(warehouse.remapellidos) ? '' : warehouse.remapellidos;

          return warehouse;
        })
        .subscribe((warehouse) => {
              this.warehouse = warehouse;
              this._setearDestinatario(warehouse);
              this.stblHistoria.data = this.warehouse.historia;
            }, (response) => {
              this._logger.debug(response);
              this._errorService.manejaError(response)
            },
            () => stopWaitMe(this._idRootPanel)
        );
  }

  onGenerarOrdenPago(evento: { status: boolean, message: any, servicio: WhrProductoCotizacionModel }) {
    $(this._idCotizaWHRModal).modal('hide');
    if (evento.status) {
      let msg = this._translate.instant('ORDEN_PAGO_NRO_CREADA', {refinterna: evento.message.refinterna});
      notify(msg, SUCCESS_NOTIFY);
      setTimeout(() => {
        $(this._ordenPagoModal).modal('show');
        this.ordenPagoRef = evento.message.refinterna;
      }, 500)
    } else {
      this._errorService.errorGeneral(evento.message);
    }
  }

  enviarComentario() {
    this.detalleNewComentario.hasError = false;

    if (this.detalleNewComentario.comentario != '') {
      this.enviandomensaje = true;

      this._http.post<string>(`${CONTROL_APP_CONST.API_URL}comentarioWarehouse`,
          {
            comentario: this.detalleNewComentario.comentario,
            nrowhr: this.warehouse.nrowhr
          })
          .subscribe(
              (response) => {
                notify(this._translate.instant('OK_REGIST_COMENT_WHR_LABEL'), SUCCESS_NOTIFY);
                $(this._idAddComentWHRModal).modal('hide');
                this.enviandomensaje = false;
                this.consultaWarehouse();
              },
              (error) => {
                this._errorService.manejaError(error);
                this.enviandomensaje = false;
              });

    } else {
      this.detalleNewComentario.hasError = true;
      this.detalleNewComentario.errorText = 'CAMPO_REQUIRED_LABEL';
    }
  }

  onOrdenPagoAnulado(response) {
    if (response.success) {
      $(this._ordenPagoModal).modal('hide');
      setTimeout(() => {
        notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
      }, 500);
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  onOrdenPagoComprobado(response) {
    if (response.success) {
      $(this._ordenPagoModal).modal('hide');
      setTimeout(() => {
        notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
      }, 500);
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  checkForm() {
    let resp = false;

    this.checkFormEdit.hasErrorVlrDeclarado = false;
    this.checkFormEdit.hasErrorPaqdesc = false;

    if (this.warehouseEdit.valordeclarado < this._minVlrDeclarado || this.warehouseEdit.valordeclarado > this._limitVlrDeclarado) {
      this.checkFormEdit.hasErrorVlrDeclarado = true;
      this.checkFormEdit.errorTextVlrDeclarado = this._translate.instant('VLRDEC_WHR_INVALID_LABEL',
          {
            maximo_declarado: this._limitVlrDeclarado,
            minimo_declarado: this._minVlrDeclarado
          });
      resp = true;
    }

    if (this._showCotizarAfterUpdate && this.warehouseEdit.paqdesc == '' || this.warehouseEdit.paqdesc == null) {
      this.checkFormEdit.hasErrorPaqdesc = true;
      resp = true;
    }

    return resp;
  }

  enviarCambiosWhr() {
    if (this.checkForm()) {
      return false;
    }

    let dataUpdate = {
      nrowhr: this.warehouseEdit.nrowhr,
      valordeclarado: this.warehouseEdit.valordeclarado,
      paqdesc: this.warehouseEdit.paqdesc,
    };

    let optionWait = new WaitMeOptionModel();
    let oldValDec = this.warehouse.valordeclarado;

    optionWait.effect = 'win8';

    initWaitMe('#contendEdicionModal', optionWait);

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaActu + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        this._http.put<any>(`${CONTROL_APP_CONST.API_URL}edicionWarehouse`, dataUpdate)
            .subscribe(
                (response) => {
                  stopWaitMe('#contendEdicionModal');
                  $(this._editarWarehouseModal).modal('hide');

                  this.warehouse = cloneDeep(this.warehouseEdit);

                  if (this.warehouse.valordeclarado > this._limitVlrAsegurado) {
                    this.warehouse.valorasegurado = this._limitVlrAsegurado;
                  } else if (this.warehouse.valordeclarado < this._minVlrAsegurado) {
                    this.warehouse.valorasegurado = this._minVlrAsegurado;
                  } else {
                    this.warehouse.valorasegurado = this.warehouse.valordeclarado;
                  }

                  if (oldValDec != this.warehouse.valordeclarado && this.warehouse.valordeclarado > 0) {
                    this.cotizarData.setFromWarehouse(cloneDeep(this.warehouse));
                  }

                  if (this._showCotizarAfterUpdate) {
                    setTimeout(() => {
                      $(this._idCotizaWHRModal).modal('show');
                    }, 400);
                    this._showCotizarAfterUpdate = false;
                  }

                  notify(this._translate.instant(response), SUCCESS_NOTIFY);
                }, (error) => {
                  stopWaitMe('#contendEdicionModal');
                  this._errorService.manejaError(error);
                }
            )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#contendEdicionModal');
      }
    });
  }

  checkEnBodega() {
    return (!this._validatorService.isEmpty(this.warehouse.id) && (this._validatorService.isEmpty(this.warehouse.guia) &&
        this._validatorService.isEmpty(this.warehouse.newordenpago) && !this.warehouse.despachado));
  }

  cotizar() {
    //Reviso que el Warehouse tenga un valor declarado y que la descripcion del paquete no sea mayor a la permitida
    if (this._validatorService.isEmpty(this.warehouse.valordeclarado)
        || this.warehouse.valordeclarado <= 0
        || this._validatorService.isEmpty(this.warehouse.paqdesc)
        || this.warehouse.paqdesc.length > this.OBSERVACION_MAX_LENGTH) {
      Swal(
          this._WAREHOSE_INCOMPLETE,
          this._EDITA_WHR_ADD_VALDEC,
          'warning').then(() => {
        this.showEditarWHRModal();
        this._showCotizarAfterUpdate = true;
      });
      return false;
    }

    this.cotizarData.setFromWarehouse(cloneDeep(this.warehouse));

    $(this._idCotizaWHRModal).modal('show');
  }

  showComentarioModal() {
    $(this._idAddComentWHRModal).modal('show');
    this.detalleNewComentario.hasError = false;
  }

  private _setearDestinatario(data: WharehouseModel) {
    if (!this._validatorService.isEmpty(data.cotizacion)
        && !this._validatorService.isEmpty(data.cotizacion.destinatario)
        && !this._validatorService.isEmpty(data.cotizacion.desdireccion)) {
      this._destinatario.apellidos = data.cotizacion.destinatario.apellidos;
      this._destinatario.email = this._validatorService.isEmpty(data.cotizacion.destinatario.email) ? '' : data.cotizacion.destinatario.email;
      this._destinatario.id = data.cotizacion.destinatario.id;
      this._destinatario.idbox = this._validatorService.isEmpty(data.cotizacion.destinatario.idbox) ? '' : data.cotizacion.destinatario.idbox;
      this._destinatario.identificacion = data.cotizacion.destinatario.identificacion;
      this._destinatario.nombres = data.cotizacion.destinatario.nombres;
      this._destinatario.telefono = this._validatorService.isEmpty(data.cotizacion.destinatario.telefono) ? '' : data.cotizacion.destinatario.telefono;
      this.des_direccion = this._getTextoDireccion(data.cotizacion.ciudaddestino.departamento.pais.nombre,
          data.cotizacion.ciudaddestino.departamento.nombre,
          data.cotizacion.ciudaddestino.nombre,
          data.cotizacion.desdireccion.direccion,
          data.cotizacion.desdireccion.zip,
      )
    } else if (!this._validatorService.isEmpty(data.notificacion)
        && !this._validatorService.isEmpty(data.notificacion.destinatario)
        && !this._validatorService.isEmpty(data.notificacion.desdireccion)) {
      this._destinatario.apellidos = data.notificacion.destinatario.apellidos;
      this._destinatario.email = this._validatorService.isEmpty(data.notificacion.destinatario.email) ? '' : data.notificacion.destinatario.email;
      this._destinatario.id = data.notificacion.destinatario.id;
      this._destinatario.idbox = this._validatorService.isEmpty(data.notificacion.destinatario.idbox) ? '' : data.notificacion.destinatario.idbox;
      this._destinatario.identificacion = data.notificacion.destinatario.identificacion;
      this._destinatario.nombres = data.notificacion.destinatario.nombres;
      this._destinatario.telefono = this._validatorService.isEmpty(data.notificacion.destinatario.telefono) ? '' : data.notificacion.destinatario.telefono;
      this.des_direccion = this._getTextoDireccion(data.notificacion.ciudaddestino.departamento.pais.nombre,
          data.notificacion.ciudaddestino.departamento.nombre,
          data.notificacion.ciudaddestino.nombre,
          data.notificacion.desdireccion.direccion,
          data.notificacion.desdireccion.zip,
      )
    } else {
      this._destinatario.apellidos = data.desapellidos;
      this._destinatario.email = data.desemail;
      this._destinatario.id = data.desid;
      this._destinatario.idbox = data.desidbox;
      this._destinatario.identificacion = data.desidentificacion;
      this._destinatario.nombres = data.desnombres;
      this._destinatario.telefono = data.destelefono;

      if(this._validatorService.isEmpty(data.ciudaddes)){
        this.des_direccion = '';
      }else {
        this.des_direccion = this._getTextoDireccion(data.ciudaddes.departamento.pais.nombre,
            data.ciudaddes.departamento.nombre, data.ciudaddes.nombre, data.desdireccion,
            data.deszip)
      }
    }
  }

  private _getTextoDireccion(pais, departamento, ciudad, direccion, zip) {
    return ' <span><b>' + pais + ' - ' + departamento + ' - ' + ciudad + '</b></span>'
        + '<br><span>' + direccion + '</span>'
        + '<br><span class="font-bold">' + this._CODIGO_POSTAL_LABEL + '</span>:&nbsp;' + zip
  }

  get destinatario() {
    return this._destinatario;
  }

  ngOnDestroy() {
    this._userInfoSubscription.unsubscribe();
    this._geparametersSubcription.unsubscribe();
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/control-app/views/whr/whr-detalle/whr-detalle.component.ts